import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Student } from './../models/student';

@Injectable({
    providedIn: 'root'
})

export class StudentService {
    controller = 'Student';

    constructor(private base: BaseService) { }

    get(id: number): Observable<ApiObjectData> {
        return this.base.get(id, this.controller + '/GetStudentById');
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAllStudents');
    }

    getStudentNotification(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetStudentNotification/' + id)
    }

    save(obj: Student) {
        return this.base.save(this.controller + '/RegisterStudent', obj);
    }

    remove(id: number) {
        return this.base.remove(this.controller, id);
    }
}